import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import RequiresVisitor from './RequiresVisitor';
import HomeOne from './components/HomeOne';
import HomeTwo from './components/HomeTwo';
import HomeThree from './components/HomeThree';
import Services from './components/Services';
import Blog from './components/Blog';
//import BlogDetails from './components/BlogDetails';
import Team from './components/Team';
import ServiceSingle from './components/ServiceSingle';
//import Shop from './components/Shop';
import ShopSingle from './components/ShopSingle';
import Cart from './components/Cart';
import Login from './components/Login';
import MobileRepair from './components/MobileRepair';
import PCLaptopRepair from './components/PCLaptopRepair';
import GameRepair from './components/GameRepair';
import Monitoring from './components/Monitoring';
import Consulting from './components/Consulting';
import DeviceRepair from './components/DeviceRepair';
import Contact from './components/Contact';
import Redirects from './Redirects';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <Redirects />
      <Routes>
        {/* Main routes */}
        <Route path="/" element={<HomeTwo />} />
        <Route path="/home-one" element={<HomeOne />} />
        <Route path="/home-two" element={<HomeTwo />} />
        <Route path="/home-three" element={<HomeThree />} />
        {/*<Route path="/services" element={<Services />} */}
        <Route path="/blog" element={<Blog />} />
       {/* <Route path="/blog-details" element={<BlogDetails />} */}
        <Route path="/team" element={<Team />} />
        <Route path="/service-single" element={<ServiceSingle />} />
        {/* <Route path="/shop" element={<Shop />} />*/}
        <Route path="/shop-single" element={<ShopSingle />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<RequiresVisitor><Login /></RequiresVisitor>} />
        <Route path="/services" element={<Services />} />
        <Route path="/mobile-repair" element={<MobileRepair />} />
        <Route path="/pc-laptop-repair" element={<PCLaptopRepair />} />
        <Route path="/game-repair" element={<GameRepair />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/device-repair" element={<DeviceRepair />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* Legacy URL routes for SEO - these will be redirected by the Redirects component */}
        <Route path="/pc-computer-repair" element={<PCLaptopRepair />} />
        <Route path="/services-2" element={<DeviceRepair />} />
        <Route path="/services-3" element={<Monitoring />} />
        <Route path="/blank-1" element={<Monitoring />} />
        <Route path="/book-online" element={<Contact />} />
        <Route path="/isf-assistant" element={<Contact />} />
        <Route path="/portal-home" element={<Monitoring />} />
        <Route path="/booking-calendar/meeting-with-tech-expert" element={<Contact />} />
        
        {/* 404 fallback */}
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
